import { createSelector } from '@reduxjs/toolkit';

import { initialState } from './store';

const selectVideoanalyticsSlice = (state) => state.videoAnalytics || initialState;

export const selectVaStreamOptions = (state) => state.videoAnalytics.streamOptions;

const selectAvailableAnalytics = createSelector(
  selectVideoanalyticsSlice,
  ({ availableAnalytics }) => availableAnalytics,
);

export const selectAvailableAnalyticsList = createSelector(
  selectAvailableAnalytics,
  (availableAnalytics) => availableAnalytics.flatMap(({ analytic_name }) => analytic_name),
);

export const selectAnalyticData = createSelector(
  selectVideoanalyticsSlice,
  (_, key) => key,
  (analyticStore, key) => analyticStore?.[key],
);

export const selectVAStreamById = createSelector(
  selectVideoanalyticsSlice,
  (_, id) => id,
  ({ byId }, streamId) => byId[streamId],
);
